import type { IconSvgObject } from './types';

const CornerDownLeftIcon: IconSvgObject = [
  ["path", { d: "M9 10.002L4 15.002L9 20.002M5 15.002H17C18.6569 15.002 20 13.6588 20 12.002V4.00195", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default CornerDownLeftIcon;
